module.exports = __webpack_public_path__ + "static/img/057.4d0f904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/057.png
// module id = T5xb
// module chunks = 0